<template>
  <div id="app-main">
    <div class="row">
      <div class="col">
        <div class="page-title-box">
          <h4 class="page-title">课程详情</h4>
          <!-- <div class="course-breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="usable-breadcrumb" :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item class="usable-breadcrumb" :to="{ path: '/course' }">
                课程列表
              </el-breadcrumb-item>
              <el-breadcrumb-item class="disable-breadcrumb">
                {{ courseInfo.fullname }}
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div> -->
        </div>
      </div>
    </div>
    <div class="row">
      <div class="course-box col-md-12 col-lg-8 col-xl-9">
        <div class="course-card card-box flex-start flex-between">
          <div class="col-4 cover-box">
            <div class="cover-img">
              <div
                class="img-src"
                :style="
                  courseInfo.img_url ? { backgroundImage: 'url(' + courseInfo.img_url + ')' } : {}
                "
              ></div>
            </div>
            <!-- <div class="source-cover">
              <img class="cover-img" :src="courseInfo.img_url" />
            </div> -->
          </div>
          <div class="col-8 course-info">
            <div class="flex-column">
              <div class="flex-between">
                <div class="course-name">{{ courseInfo.fullname }}</div>
                <div class="tag-box">
                  <div class="tag-box-inner end" v-if="courseInfo.status === 0">
                    <i class="mdi mdi-book-open-variant"></i>
                    <span>&nbsp;已结束</span>
                  </div>
                  <div class="tag-box-inner start" v-if="courseInfo.status === 1">
                    <i class="mdi mdi-book-open-page-variant"></i>
                    <span>&nbsp;进行中</span>
                  </div>
                  <div class="tag-box-inner not-start" v-if="courseInfo.status === 2">
                    <i class="mdi mdi-book-open-page-variant"></i>
                    <span>&nbsp;未开始</span>
                  </div>
                  <div class="tag-box-bottom"></div>
                </div>
              </div>
              <div>
                <div class="course-time">
                  <i class="mdi mdi-clock-outline text-primary"></i>
                  {{ courseInfo.courseTime }}
                </div>
                <div class="course-teacher">
                  <i class="mdi mdi-account-tie text-primary"></i>
                  <span class="teacher-list">教师：{{ courseInfo.teacher }}</span>
                </div>
              </div>

              <div class="course-intro">
                <div class="intro-content" v-html="courseInfo.summary"></div>
              </div>
              <div class="btn-group">
                <el-button class="operate-btn" type="primary" @click="viewCourse">
                  查看课程
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="update-box col-md-12 col-lg-4 col-xl-3">
        <div class="update-card card-box flex-start flex-column">
          <div class="card-title">课程更新</div>
          <div v-if="isExpired" class="update-tips">当课程结束时间已过，课程不再更新</div>
          <div class="update-time-tip-box">
            <div class="last-update-time flex-start time-box">
              <div class="icon-box">
                <i class="mdi mdi-clock-check-outline text-primary"></i>
              </div>
              <div class="time-text">
                <span class="update-tips">最近一次更新：</span>
                <span class="update-time">
                  {{ courseInfo.last_update_time.replace(/-/g, '.') }}
                </span>
              </div>
            </div>
            <div class="next-update-time flex-start time-box">
              <div class="icon-box">
                <i class="mdi mdi-reload text-success"></i>
              </div>
              <div class="time-text">
                <span class="update-tips">下一次更新：</span>
                <span class="update-time">{{ nextUpdateTime }} 00:00:00</span>
              </div>
            </div>
          </div>

          <div class="btn-group flex-between">
            <el-button
              class="operate-btn"
              type="primary"
              :disabled="!updateUsable"
              @click="updateCourseStatsApi"
              v-if="![6, 7].includes(userInfo.role_id)"
            >
              更新统计
            </el-button>
            <el-button
              class="operate-btn"
              type="outline"
              @click="updateCourseTime"
              v-if="![6, 7].includes(userInfo.role_id)"
            >
              更改课程时间
            </el-button>
            <div v-if="[6, 7].includes(userInfo.role_id)" style="height: 40px"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <el-card class="course-detail-info">
          <el-menu
            router
            :default-active="onRoutes"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              v-show="![6, 7].includes(userInfo.role_id)"
              :index="'/courseDetail/baseInfo?courseId=' + courseId"
            >
              基本情况
            </el-menu-item>
            <el-menu-item
              v-show="![6, 7].includes(userInfo.role_id)"
              :index="'/courseDetail/teachCount?courseId=' + courseId"
            >
              教学统计
            </el-menu-item>
            <el-menu-item
              v-show="![6, 7].includes(userInfo.role_id)"
              :index="'/courseDetail/studyAnalyse?courseId=' + courseId"
            >
              学情分析
            </el-menu-item>
            <el-menu-item
              v-show="![6, 7].includes(userInfo.role_id)"
              :index="'/courseDetail/studentDoc?courseId=' + courseId"
            >
              学员档案
            </el-menu-item>
            <el-menu-item
              v-show="![6, 7].includes(userInfo.role_id)"
              :index="'/courseDetail/abnormalWarn?courseId=' + courseId"
            >
              异常预警
            </el-menu-item>
            <el-menu-item
              v-show="userInfo.role_id == 6"
              :index="
                '/courseDetail/myDoc?courseId=' + courseId + '&userId=' + this.userInfo.mdl_userid
              "
            >
              我的档案
            </el-menu-item>
            <template>
              <div
                v-if="![6, 7].includes(userInfo.role_id)"
                class="fliter-setting flex-end"
                @click="filterDialogVisible = true"
              >
                <i class="mdi mdi-filter-outline"></i>
                <span>筛选设置</span>
              </div>
            </template>
          </el-menu>
          <router-view></router-view>
        </el-card>
      </div>
      <el-dialog
        class="message-dialog"
        title="筛选设置"
        :visible.sync="filterDialogVisible"
        width="20%"
      >
        <div class="message-item">
          <div class="item-title">筛选维度</div>
          <div class="item-content">
            <el-radio-group v-model="filterDimension">
              <el-radio :label="1">按小组</el-radio>
              <el-radio :label="2">按选课方式</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="message-item">
          <div class="item-title">是否包括已暂停用户</div>
          <div class="item-content">
            <el-radio-group v-model="filterUser">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="filterDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmFilter">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { domainName } from '@/config/setting.js'
export default {
  data() {
    return {
      // 基本情况
      isExpired: true,
      courseInfo: {
        last_update_time: '',
        start_time: '',
        end_time: '',
      },
      // 教学统计消息提醒
      filterDialogVisible: false,
      filterDimension: '',
      filterUser: '',
      updateUsable: true,
      //
      updateTimer: null,
    }
  },
  computed: {
    ...mapState({
      userInfo(state) {
        return state.commom.userInfo
      },
      roleList(state) {
        return state.commom.roleList
      },
      routesStartPath() {
        console.log('this.$route.path', this.$route.path)
        return this.$route.path
      },
    }),
    onRoutes() {
      const path = this.$route.path
      // 在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
      // meta中 有activeMenu 字段的子页面，都会显示高亮
      console.log('path:', path)
      if (path.startsWith('/courseDetail/baseInfo')) {
        return '/courseDetail/baseInfo?courseId=' + this.courseId
      } else if (path.startsWith('/courseDetail/teachCount')) {
        return '/courseDetail/teachCount?courseId=' + this.courseId
      } else if (path.startsWith('/courseDetail/studyAnalyse')) {
        return '/courseDetail/studyAnalyse?courseId=' + this.courseId
      } else if (path.startsWith('/courseDetail/studentDoc')) {
        return '/courseDetail/studentDoc?courseId=' + this.courseId
      } else if (path.startsWith('/courseDetail/abnormalWarn')) {
        return '/courseDetail/abnormalWarn?courseId=' + this.courseId
      } else if (path.startsWith('/courseDetail/myDoc')) {
        return (
          '/courseDetail/myDoc?courseId=' + this.courseId + '&userId=' + this.userInfo.mdl_userid
        )
      }
      return path
    },
    courseId() {
      return this.$route.query.courseId
    },
    // 下一次更新统计时间
    nextUpdateTime() {
      let nextDayTime = new Date(Date.now() + 86400000)
      return `${nextDayTime.getFullYear()}.${
        nextDayTime.getMonth() + 1 < 10
          ? '0' + (nextDayTime.getMonth() + 1)
          : nextDayTime.getMonth() + 1
      }.${nextDayTime.getDate()}`
    },
  },
  mounted() {
    // 当前角色非学生或游客时才调用查询课程更新接口
    if (![6, 7].includes(this.userInfo.role_id)) {
      this.getCourseUpdateStatsApi()
    }
    this.getCourseDetailApi()
  },
  beforeDestroy() {
    clearInterval(this.updateTimer)
  },
  methods: {
    // 查看课程
    viewCourse() {
      window.open(domainName + '/course/view.php?id=' + this.courseId, '_blank')
    },
    // 更改课程时间
    updateCourseTime() {
      window.open(domainName + '/course/edit.php?id=' + this.courseId, '_blank')
    },
    // 获取课程详情接口
    async getCourseDetailApi() {
      await this.$store
        .dispatch('course/getCourseDetail', {
          course_id: Number(this.$route.query.courseId),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseInfo = res.data
            if (this.courseInfo.end_time !== '') {
              this.courseInfo['courseTime'] = `${this.courseInfo.start_time?.replace(/-/g, '.')} 至
                  ${this.courseInfo.end_time?.replace(/-/g, '.')}`
            } else {
              this.courseInfo['courseTime'] = `${this.courseInfo.start_time?.replace(/-/g, '.')} 起`
            }
            this.filterDimension = this.courseInfo.search_setting
            this.filterUser = this.courseInfo.include_stop_user
            this.$store.commit('course/setCourseInfo', this.courseInfo)
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },

    handleSelect(key, keyPath) {
      console.log(key)
      console.log(keyPath)
    },
    // 查询课程更新统计状态接口
    async getCourseUpdateStatsApi() {
      await this.$store
        .dispatch('course/getCourseUpdateStats', {
          course_id: Number(this.$route.query.courseId),
        })
        .then(res => {
          console.log('1111res:', res.data.status)
          if (res.code === 1) {
            if (res.data.status == 0) {
              if (this.updateUsable) {
                this.updateUsable = false
              }
              if (!this.updateTimer) {
                this.updateTimer = setInterval(() => {
                  this.getCourseUpdateStatsApi()
                }, 1000)
              }
            } else if (res.data.status == 1) {
              this.updateUsable = true

              if (this.updateTimer) {
                clearInterval(this.updateTimer)
                this.$notify.success({
                  title: '更新统计已完成',
                  message: '即将在3秒后刷新页面',
                })
                setTimeout(() => {
                  window.location.reload()
                }, 3000)
              }
            } else if (res.data.status == 2) {
              this.updateUsable = true
              if (this.updateTimer) {
                clearInterval(this.updateTimer)
                this.$notify.warning({
                  title: '更新统计失败',
                })
              }
            }
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 点击执行更新统计接口
    async updateCourseStatsApi() {
      await this.$store
        .dispatch('course/updateCourseStats', {
          course_id: Number(this.$route.query.courseId),
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$message.success('更新中，当更新完成后页面会自动刷新')
            this.getCourseUpdateStatsApi()
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 筛选设置接口
    async confirmFilter() {
      await this.$store
        .dispatch('course/setCourseFilter', {
          course_id: +this.$route.query.courseId,
          search_setting: +this.filterDimension,
          include_stop_user: +this.filterUser,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.$message.success('设置成功')
            this.filterDialogVisible = false
            this.getCourseDetailApi()
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .el-breadcrumb {
    .el-breadcrumb__item {
      .el-breadcrumb__inner {
        font-size: 14px;
        color: #adb5bd;
        line-height: 14px;
      }
      .el-breadcrumb__inner.is-link {
        color: #6c757d;
      }
    }
  }
}
.page-title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  h4.page-title {
    font-weight: 600;
  }
}
.operate-btn {
  margin-right: 12px;
  width: 120px;
}
.course-card {
  height: auto;
  .cover-img {
    width: 100%;
    height: 220px;
    overflow: hidden;
    .img-src {
      width: 100%;
      height: 100%;
      background-repeat: no-repeat;
      background-position-x: center;
      background-size: cover;
    }
  }
  .cover-box {
    padding: 16px;
    background-color: #f3f7f9;
    height: calc(100% * 9 / 16);

    .source-cover {
      position: relative;
      min-height: 220px;
      overflow: hidden;
      .cover-img {
        position: absolute;
        top: 50%;
        left: 50%;
        display: block;
        min-width: 100%;
        min-height: 100%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }
    }
  }
  .course-info {
    padding-left: 48px;

    .course-name {
      margin-top: 16px;
      margin-bottom: 32px;
      font-size: 24px;
      font-weight: bold;
      color: #343a40;
      line-height: 24px;
    }
    .tag-box {
      position: relative;

      .tag-box-inner {
        width: 94px;
        height: 31px;
        line-height: 31px;
        text-align: center;
        position: absolute;
        white-space: nowrap;
        right: -40px;
        border-radius: 4px 0px 0px 4px;
      }
      .end {
        background: #6c757d;
        color: #ffffff;
      }
      .start {
        background-color: rgba(50, 131, 246, 1);
        color: white;
      }
      .not-start {
        background-color: #dbe9fe;
        border: 1px solid rgba(50, 131, 246, 1);
        color: #3283f6;
      }
      .tag-box-bottom {
        position: absolute;
        right: -39.8px;
        top: 30.2px;
        width: 0;
        height: 0;
        border-bottom: 4.28px solid rgba(50, 131, 246, 1);
        border-right: 4.28px solid transparent;
        border-left: 4.28px solid transparent;
        transform: rotate(-45deg);
      }
    }
    .course-time {
      margin-right: 40px;
      margin-bottom: 16px;
      font-size: 16px;
      color: #6c757d;
      line-height: 16px;
      .mdi {
        margin-right: 10px;
      }
    }
    .course-teacher {
      margin-right: 40px;
      margin-bottom: 32px;
      font-size: 16px;
      color: #6c757d;
      line-height: 16px;
      .mdi {
        margin-right: 10px;
      }
      .teacher-list {
      }
    }
    .intro-icon {
      padding: 0 8px 2px 0;
    }
    .course-intro {
      .intro-title {
        font-size: 16px;
        font-weight: bold;
        color: #343a40;
        line-height: 16px;
      }
      .intro-content {
        height: 21px;
        margin-bottom: 22px;
        font-size: 14px;
        color: #98a6ad;
        line-height: 21px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.update-card {
  height: auto;
  .card-title {
    margin-bottom: 7px;
    font-size: 16px;
    font-weight: bold;
    color: #343a40;
    line-height: 16px;
  }
  .update-time-tip-box {
    width: 100%;
  }
  .time-box {
    width: 100%;
    margin-top: 6px;
    padding: 13px 16px;
    background-color: rgba(243, 247, 249, 1);

    .mdi {
      font-size: 20px;
    }
  }
  .last-update-time {
    margin-top: 24px;
    border-radius: 4px;
    .icon-box {
      background: rgba(50, 148, 246, 0.25);
    }
  }
  .next-update-time {
    border-radius: 4px;
    .icon-box {
      background: rgba(68, 207, 156, 0.25);
    }
  }
  .icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 4px;
  }
  .time-text {
    margin-left: 16px;
    line-height: 32px;
    white-space: nowrap;
  }
  .update-tips {
    font-size: 14px;
    color: #98a6ad;
    line-height: 21px;
  }
  .update-time {
    font-size: 14px;
    color: #6c757d;
    line-height: 14px;
  }
  .btn-group {
    width: 100%;
    margin-top: 24px;
    .operate-btn {
      width: 48%;
    }
  }
}
.course-detail-info {
  .el-menu-demo {
    margin-bottom: 24px;

    .fliter-setting {
      float: right;
      white-space: nowrap;
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #3294f6;
      cursor: pointer;
      .mdi {
        font-size: 17px;
      }
    }
  }
}
.message-dialog {
  ::v-deep .el-dialog__body {
    padding-bottom: 0px;
  }

  .message-item {
    font-size: 14px;
    color: #6c757d;
    margin-bottom: 24px;
    .item-title {
      margin-bottom: 8px;
    }
    .item-content {
    }
  }
}
// ::v-deep {
//   .teacher-count {
//     .el-link {
//       text-decoration: underline;
//     }
//     .el-table thead.is-group th.el-table__cell {
//       background: #f5f7fa;
//     }
//   }
// }
@media screen and (max-width: 1580px) and (min-width: 1369px) {
  .course-box {
    flex: 0 0 66.66667% !important;
    max-width: 66.66667% !important;
  }
  .update-box {
    flex: 0 0 33.33333% !important;
    max-width: 33.33333% !important;
  }
}
@media screen and (max-width: 1368px) {
  .course-box {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .update-box {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
  .update-time-tip-box {
    display: flex;
    .last-update-time {
      margin-top: 0;
      margin-right: 6px;
    }
    .next-update-time {
      margin-top: 0;
    }
  }
  .update-card {
    .btn-group {
      .operate-btn {
        width: 50%;
        margin-right: 0;
      }
    }
  }
}
</style>
